import type { TolgeeInstance } from '@tolgee/web';

/**
 * Handle on the live Tolgee instance created by `setupI18nAsync`.
 *
 * Deliberately a leaf module: `i18nSetup` and `i18nLayer` already import each
 * other, and consumers of `stripTranslationMarkers` should not be dragged into
 * that cycle — or into i18next — just to read one value.
 */
let instance: TolgeeInstance | undefined;

export const setTolgee = (tolgee: TolgeeInstance): void => {
	instance = tolgee;
};

export const getTolgee = (): TolgeeInstance | undefined => instance;
